import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Image as SemanticImage, Divider, Container, Card } from 'semantic-ui-react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from "@mui/material/Typography";
import CloseIcon from '@mui/icons-material/Close';
import Button from "@mui/material/Button";

import { MOMENT_DOWNLOAD_URL } from 'shared/utils/Constants';

const styles = theme => ({
    modal: {
        display: 'flex',
        alignItems: 'start',
        justifyContent: 'center',
        overflowY: 'auto'
    },
    paper: {
        position: 'relative',
        top: '4rem',
        backgroundColor: theme.palette.background.paper,
        borderRadius: '4px',
        boxShadow: theme.shadows[5],
        padding: '20px',
        //padding: theme.spacing(2, 2, 3),
        minWidth: '300px',
        maxWidth: '62vw',
        width: '100%',
    },
    paperWide: {
        position: 'relative',
        top: '4rem',
        backgroundColor: theme.palette.background.paper,
        borderRadius: '4px',
        boxShadow: theme.shadows[5],
        padding: '1.5rem 2rem 2rem',
        //padding: theme.spacing(2, 4, 3),
        maxWidth: '1200px',
        width: '100%',
    },
    closeIcon: {
        position: 'absolute',
        top: 0,
        right: 0,
        padding: '0.5rem',
        fontSize: '3rem !important',
        color: '#888',
        cursor: 'pointer'
    },
    imgComponent: {
        height: '20vh',
        alignSelf: 'center'
    },
    imageContainer: {
        display: 'flex',
        width: '760px',
        flexWrap: 'wrap',
        justifyContent: 'left'
    }
});


const AspectList = (props) => {
    const { classes, getData, isOpen, onClose, selectedItem } = props;
    const [data, setData] = useState([]);
    const [loaded, setLoaded] = useState(false);

    let boxClass = classes.paper,
        boxStyle = { maxWidth: "670px" },
        headerVariant = 'h5';

    const aspectRatios = {
        1: "4x3",
        2: "3x2",
        3: "7x5",
        4: "5x4",
        5: "1x1"
    }

    useEffect(() => {
        if (!loaded) {
            if (getData) {
                getData(selectedItem.id).then(result => {
                    setData(result);
                    setLoaded(true);
                })
            }
        }
    }, [loaded, isOpen])

      const download = (overlay) => {
        let link = document.createElement('a');

        link.href = MOMENT_DOWNLOAD_URL(overlay.moment_id);
        link.download = `overlay-${overlay.id}`;
        link.click();
      }

    const handleDelete = async (id) => {
        const deleteMsg = "Are you sure you want to remove this aspect? It will be removed from this product";
        if (window.confirm(deleteMsg) === true) {
            if (props.type === 'overlay') {
                await props.onDelete(props.jobConfig.product_id, selectedItem.id, id).then(() => {
                    setLoaded(false);
                })
            } else {
                await props.onDelete(props.user.account.id, selectedItem.id, id).then(() => {
                    setLoaded(false);
                })
            }
        }
    }

    return <Modal open={isOpen} onClose={onClose} className={classes.modal}>
        <Box className={boxClass} style={boxStyle}>
            <Container>
                <CloseIcon className={classes.closeIcon} onClick={onClose} />
                <Typography variant={headerVariant} className={classes.formTitle}>
                    {props.title}
                </Typography>
                <Divider />
                <Card.Group>
                    {
                        data.map((item, index) => {
                            return <Card key={index} >
                                <Card.Content>
                                    <SemanticImage src={item.url} label={{ color: 'blue', ribbon: true, icon: 'expand', content: aspectRatios[item.aspect] }} />
                                </Card.Content>
                                <Card.Content extra>
                                    <div className='ui two buttons'>
                                        <Button fullWidth variant="contained"  onClick={() => download(item)}>Download</Button>
                                        <Button fullWidth variant="contained" onClick={() => handleDelete(item.id)}>Remove</Button>
                                    </div>
                                </Card.Content>
                            </Card>
                        })
                    }
                </Card.Group>
            </Container>
            <Divider />
            <Button fullWidth variant="contained" component="label" onClick={props.onClick}>
                <input
                    type="file"
                    accept={props.acceptedTypes || 'image/*'}
                    hidden
                    onChange={async (e) => {
                        await props.addSize(e, selectedItem.id);
                        setLoaded(false);
                    }}
                />
                Add Size</Button>
            <Button fullWidth variant="contained" onClick={onClose}>Close</Button>
        </Box>
    </Modal>
}

const mapStateToProps = state => ({
    darkMode: state.portalReducer.darkMode,
    user: state.userReducer.user
});

export default connect(mapStateToProps, {})(withStyles(styles, { withTheme: true })(AspectList));
